import { render } from "./reservation_card.vue?vue&type=template&id=faca916a"
import script from "./reservation_card.vue?vue&type=script&lang=js"
export * from "./reservation_card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__